import { styled } from '@mui/material';

const LogRecordContainer = styled('div')`
  height: ${({ rows }: any) => rows > 5 ? '368px' : 'auto' };
`;

export default LogRecordContainer as any;
